import {GET_PROCESS_PERMISSION, GET_USER_NAME, GET_USER_PERMISSION, GET_USER_HANDLPER, GET_USER_INFO, GET_LS_PERMISSION, GET_LS_CITY, GET_LS_DEPARTMENT, GET_LS_STATUS_CV, GET_LS_STATUS_TICKET} from "./actionTypes";

export const getUser = (state) => {
  return {
      type: GET_USER_NAME,
      payload: state
  };
};

export const getUserPermission = (state) => {
  return {
      type: GET_USER_PERMISSION,
      payload: state
  };
};

export const getProcessPermission = (state) => {
  return {
      type: GET_PROCESS_PERMISSION,
      payload: state
  };
};

export const getHandlPermission = (state) => {
  return {
      type: GET_USER_HANDLPER,
      payload: state
  };
};

export const getInfoUser = (state) => {
  return {
      type: GET_USER_INFO,
      payload: state
  };
};

export const getLsPermission = (state) => {
  return {
      type: GET_LS_PERMISSION,
      payload: state
  };
};

export const getLsCity = (state) => {
  return {
      type: GET_LS_CITY,
      payload: state
  };
};

export const getLsDepartment = (state) => {
  return {
      type: GET_LS_DEPARTMENT,
      payload: state
  };
};

export const getLsStatusCV = (state) => {
  return {
      type: GET_LS_STATUS_CV,
      payload: state
  };
};

export const getLsStatusTicket= (state) => {
  return {
      type: GET_LS_STATUS_TICKET,
      payload: state
  };
};

